import { render, staticRenderFns } from "./ConfigurationProfiles.vue?vue&type=template&id=dc8e1662&"
import script from "./ConfigurationProfiles.vue?vue&type=script&lang=ts&"
export * from "./ConfigurationProfiles.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigurationProfiles.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports